<template>
	<div class="b-form__calendar">
		<div class="b-form__calendarItem b-form__calendarItem_date date-control">
			<input type="text" autocomplete="off" :placeholder="format" data-input :value="dateValue"/>
			<span class="select_toggle b-form__calendarToggle" data-toggle>
				<i class="icon icon--arrow-down"></i>
			</span>
		</div>
		<div class="b-form__calendarItem b-form__calendarItem_time time-control" v-if="timeSeparated">
			<input type="text" autocomplete="off" :placeholder="timeFormat" data-input :value="timeValue"/>
			<span class="select_toggle b-form__calendarToggle" data-toggle>
				<i class="icon icon--arrow-down"></i>
			</span>
		</div>
	</div>
</template>

<script>
export default {
	name: "CitrusDatePickDelivery",
	props: {
		stock: {
			type: [Object, Boolean],
		},
	},
	data() {
		return {
			inputFocus: false,
			error: false,
			dateValue: "",
			timeValue: "",
			inputValue: "",
			dateOptions: {},
			timeOptions: {},
			defaultOptions: {
				locale: "ru",
				dateFormat: "Y-m-d",
				defaultDate: "",
				wrap: true,
				disable: []
			}
		}
	},
	watch: {
		value(newValue, oldValue) {
			console.log('watch datetime', newValue);
			if (this.inputValue == newValue) {
				return;
			}
			this.inputValue = newValue;
			this.initFullValue();
			this.$nextTick(this.redraw);
		},
	},
	methods: {
		onChangeTime(selectedDates, value, instance) {
			/**
			 * На мобильных устройствах в поле время не применяются ограничения, проверим вручную
			 */
			if (instance && instance.isMobile && this.timeParams) {
				var newValue = null;
				if (this.timeParams.minTime && value < this.timeParams.minTime) {
					newValue = this.timeParams.minTime;
				}

				if (this.timeParams.maxTime && value > this.timeParams.maxTime) {
					newValue = this.timeParams.maxTime;
				}

				if (newValue !== null) {
					value = newValue;
					if (instance.mobileInput) {
						instance.mobileInput.value = newValue;
					}

					if (instance.input !== undefined) {
						instance.input.value = instance.getDateStr(instance.config.dateFormat);
					}

					if (instance.altInput !== undefined) {
						instance.altInput.value = instance.getDateStr(instance.config.altFormat);
					}
				}
			}

			this.timeValue = value;
		},
		onChange(selectedDates, value, instance) {
			let isDateWarning = this.checkDate(value, this.timeValue);
			if (isDateWarning) {
				let newValue = value + " " + this.timeValue;
				this.$emit("warning", newValue);
				this.$nextTick(this.redraw);
				return;
			}

			this.dateValue = value;
			this.updateFullValue();
		},
		checkDate(dateValue, timeValue) {
			let formattedChosenDate = this.getFormattedChosenDate(dateValue, timeValue);
			formattedChosenDate.setMinutes(formattedChosenDate.getMinutes() + this.$store.getters['basket/orderMakeMinutes']);

			let availableDate = this.stock.min_date.split('.').reverse().join('-');
			let formattedAvailableDate = availableDate + `T${this.stock.min_time}`;

			return formattedChosenDate.getTime() < new Date(formattedAvailableDate).getTime();
		},
		compareIdenticalDates(dateValue, timeValue) {
			let formattedChosenDate = this.getFormattedChosenDate(dateValue, timeValue);
			let availableDate = this.stock.min_date.split('.').reverse().join('-');

			let formattedChosenDateResetTime = formattedChosenDate.setHours(0, 0, 0, 0);
			let availableDateResetTime = new Date(availableDate).setHours(0, 0, 0, 0);

			let compareResult = (formattedChosenDateResetTime === availableDateResetTime) ? true : false;

			return compareResult;
		},
		getFormattedChosenDate(dateValue, timeValue) {
			let chosenDate = dateValue.split('.').reverse().join('-');
			let formattedChosenDate = chosenDate + 'T' + timeValue;
			formattedChosenDate = new Date(formattedChosenDate);
			return formattedChosenDate;
		},
		onCloseTime() {
			if(this.compareIdenticalDates(this.dateValue, this.timeValue)) {
				let isDateWarning = this.checkDate(this.dateValue, this.timeValue);
				if (isDateWarning) {
					let newValue = this.dateValue + " " + this.timeValue;
					this.$emit("warning", newValue);
					this.$nextTick(this.redraw);
					return;
				}
			}

			this.updateFullValue();
		}
	}
}
</script>